module.exports = __webpack_public_path__ + "static/media/monster.2183d9f4.jpg";